const navToggle = document.querySelector('.js-navigation-toggle');
const navigation = document.querySelector('.js-header-body');
const loginToggle = document.querySelector('.js-login-toggle');
const loginPanel = document.querySelector('.js-login-panel');
// Execute code when the screen width matches min-width: 1024px
const mediaQuery = window.matchMedia('(min-width: 1024px)');

// Add a click event listener to the navToggle element
if (navToggle) {
	navToggle.addEventListener('click', () => {
		const isExpanded = navToggle.getAttribute('aria-expanded') === 'true';
		desktopMobileNavToggle(!isExpanded);
	});
}

// Add a click event listener to the loginToggle element
if (loginToggle) {
	loginToggle.addEventListener('click', (event) => {
		if (window.innerWidth < 1024) {
			return;
		}
		event.preventDefault();
		const isExpanded = loginPanel.getAttribute('aria-expanded') === 'true';
		desktopMobileLoginToggle(!isExpanded);
	});
}

// Listen for mobile/desktop media query event
// Force open of navigation if desktop
// Force close of navigation if mobile
function handleMediaQueryChange(event) {
	if (event.matches) {
		desktopMobileNavToggle(true);
		desktopMobileLoginToggle(false);
	} else {
		desktopMobileNavToggle(false);
		desktopMobileLoginToggle(false);
	}
}

// Toggle state of navigation and navigation open/close button
function desktopMobileNavToggle(expanded) {
	if (navToggle) {
		navToggle.setAttribute('aria-expanded', expanded);
		navigation.setAttribute('aria-expanded', expanded);
	}
}

function desktopMobileLoginToggle(expanded) {
	if (loginToggle) {
		loginPanel.setAttribute('aria-expanded', expanded);
	}
}

// Initial check
handleMediaQueryChange(mediaQuery);

// Add listener for changes
mediaQuery.addEventListener('change', handleMediaQueryChange);

// Megamenu
const megamenuTriggers = document.querySelectorAll('.js-megamenu-heading');
const megamenuClose = document.querySelectorAll('.js-megamenu-close');

// Add event listeners to the megamenuTriggers elements
const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

megamenuTriggers.forEach(link => {
	const parent = link.parentElement;

	if (isTouchDevice) {
		// Touch devices: open/close on click
		link.addEventListener('click', (event) => {
			event.preventDefault();
			const isExpanded = parent.getAttribute('aria-expanded') === 'true';

			// If setting to true, set 'aria-expanded' of siblings to 'false'
			if (!isExpanded) {
				const siblings = Array.from(parent.parentElement.children).filter(child => child !== parent);
				siblings.forEach(sibling => sibling.setAttribute('aria-expanded', 'false'));
			}

			parent.setAttribute('aria-expanded', !isExpanded);
		});
	} else {
		// Non-touch devices: hover intent with timeouts
		let enterTimeout, leaveTimeout;

		parent.addEventListener('mouseenter', () => {
			clearTimeout(leaveTimeout);
			enterTimeout = setTimeout(() => {
				const siblings = Array.from(parent.parentElement.children).filter(child => child !== parent);
				siblings.forEach(sibling => sibling.setAttribute('aria-expanded', 'false'));
				parent.setAttribute('aria-expanded', 'true');
			}, 150); // Adjust delay as needed
		});

		parent.addEventListener('mouseleave', () => {
			clearTimeout(enterTimeout);
			leaveTimeout = setTimeout(() => {
				parent.setAttribute('aria-expanded', 'false');
			}, 200); // Adjust delay as needed
		});
	}
});

// Add a click event listener to the megamenuClose elements
megamenuClose.forEach(button => {
	button.addEventListener('click', () => {
		const parentItem = button.closest('.c-navigation__item'); // Find the closest ancestor with the class "c-navigation__item"
		if (parentItem) {
			parentItem.setAttribute('aria-expanded', 'false'); // Set "aria-expanded" attribute to false
		}
	});
});

// Close megamenu or client login on outside clicks
// Listen for document click events
// If click is outside navigation or login panel, close them (set aria-expanded to false)
// If click is outside any open megamenu, close all open megamenus
function closeOpenElementsOnClickOutside() {
	document.addEventListener('click', function (event) {

		// Login Panel (desktop only)
		if (loginPanel.length) {
			if (
				window.innerWidth >= 1024 &&
				loginPanel.getAttribute('aria-expanded') === 'true' &&
				!loginPanel.contains(event.target) &&
				!loginToggle.contains(event.target)
			) {
				desktopMobileLoginToggle(false);
			}
		}

		// Megamenu
		document.querySelectorAll('.c-navigation__item[aria-expanded="true"]').forEach(item => {
			if (!item.contains(event.target)) {
				item.setAttribute('aria-expanded', 'false');
			}
		});
	});
}

// Call the method after DOM elements are defined
closeOpenElementsOnClickOutside();

import 'Vue/vue-router';
import $ from 'jquery';

import { Social as SocialShare } from 'App/social/share';
import { Cookie } from 'App/cookie/cookie';
import { BackToTop } from 'App/back-to-top/back-to-top';

import lottie from 'lottie-web';
import animationData from '../../../../images/resources/oxygen-hero.json';

const oxygenAnimation = document.getElementById('oxygen-hero');

if (oxygenAnimation) {

	const animation = lottie.loadAnimation({
		container: oxygenAnimation,
		renderer: 'svg', // or 'canvas' or 'html'
		loop: false,
		autoplay: true,
		animationData: animationData,
	});
}

SocialShare.init();
Cookie.init();
BackToTop.init();

// Publish resize and scroll events for other modules to use
import { publish } from 'Util/pubsub';
import { throttle } from 'Util/throttle';

const $window = $(window);
$window.on('resize', throttle(() => publish('/window/resize'), 250));
$window.on('scroll', () => publish('/window/scroll'));

// These modules are used often enough, or are small enough, that it's worth always loading them
import { Rte } from 'Controls/control.rte';
Rte.init();

import { Homepage } from 'Page/homepage';
Homepage.init();

// Gallery Rotator
import { GalleryRotator } from 'Controls/control.gallery-rotator';
const $galleryRotators = $('.js-gallery-rotator');

if ($galleryRotators.length) {
	GalleryRotator.init($galleryRotators);
}

// Testimonial Rotator
import { TestimonialsRotator } from 'Controls/control.testimonials-rotator';
const $testimonialsRotators = $('.js-testimonials-rotator');

if ($testimonialsRotators.length) {
	TestimonialsRotator.init($testimonialsRotators);
}

// Property Rotator
import { PropertyRotator } from 'Controls/control.property-rotator';
const $propertyRotators = $('.js-property-rotator');

if ($propertyRotators.length) {
	PropertyRotator.init($propertyRotators);
}

// Featured Article Rotator
import { FeaturedArticleRotator } from 'Controls/control.featured-article-rotator';
const $featuredarticleRotators = $('.js-featured-article-rotator');

if ($featuredarticleRotators.length) {
	FeaturedArticleRotator.init($featuredarticleRotators);
}

// Lightbox
import { Lightbox } from 'App/lightbox/lightbox';
if (document.querySelector('.js-lightbox-single, .js-lightbox-gallery')) {
	Lightbox.init();
}

// Google Maps
import { GoogleMap } from 'Controls/control.google-map';
GoogleMap.init();


// Expand and Collapse
import { expandCollapse } from 'App/expand-collapse/expand-collapse';
if (document.querySelector('.js-expand-collapse')) {
	expandCollapse.init();
}

// Listing With Filter
import { ListingWithFilter } from 'Controls/control.listing-with-filter';
ListingWithFilter.init();

//////////////////////////////////
// Any page, but not every page //
//////////////////////////////////

// Modal
if (document.querySelector('.js-modal')) {
	import(/* webpackChunkName: "Modal" */ 'App/modal/modal').then(({ modal }) => {
		modal.init({
			onShow: function ($modal) {
				var $rotators = $modal.find('.js-rotator');
				var thisFlick;
				$rotators.each(function (i, el) {
					thisFlick = $(el).data('flickity-instance');

					if (thisFlick) {
						thisFlick.resize();
					}
				});
			}
		});
	});
}

/********************************************************************************************************/

//  Inject Items into Property Details Gallery
const galleryWrapper = document.getElementById('galleryWrapper');
const galleryAllButton = document.getElementById('galleryAllButton');
const url = galleryWrapper?.dataset.api;

if (typeof url !== 'undefined' && url !== '') {
	getData(url);
}

async function getData(dataUrl) {
	try {
		const response = await fetch(dataUrl);
		if (!response.ok) {
			throw new Error(`Response status: ${response.status}`);
		}
		const json = await response.json();
		handleData(json);
	} catch (error) {
		console.error(error.message);
	}
}

function handleData(data) {

	// Clear existing content
	galleryWrapper.innerHTML = '';

	data.forEach(item => {
		const a = document.createElement('a');
		a.href = item.propertyImageURL
		a.className = 'c-property-details-gallery__item js-lightbox-image';
		/*a.innerHTML = `<img src="${item.propertyImageURL + "?width=1000&amp;height=600"}" class="c-property-details-gallery__image" alt="">`;*/
		a.innerHTML = `<picture>
			<img src="${item.propertyImageURL + "?width=900&amp;height=500"}" width="900" height="500" loading="lazy" class="c-property-details-gallery__image" alt="" style="aspect-ratio: 16/9;">
		</picture>`;
		galleryWrapper.appendChild(a);
	});

	// Crawls through list of images and gets first image
	const Images = galleryWrapper.getElementsByClassName('c-property-details-gallery__item');
	const firstImage = Images[0];

	// Trigger the gallery focussed on first image
	galleryAllButton.addEventListener('click', function () {
		firstImage.click();
	});

}

//  Property Details Scroll to map button
const ScrollToMapper = document.getElementById('ScrollToMapper');

if (ScrollToMapper) {
	ScrollToMapper.addEventListener('click', function () {
		var top_val = $('#PropertyMap');
		$('html, body').stop().animate({
			scrollTop: top_val.offset().top - 50
		}, 'slow');
	});
}

//  Accordion Gallery
const AccordionGallery = document.getElementsByClassName('c-accordion-gallery');

if (AccordionGallery) {

	const GalleryInstance = [...Object(AccordionGallery)];

	GalleryInstance.forEach(function (gallery) {

		var item = gallery.getElementsByClassName("c-accordion-gallery__item-header");
		var images = gallery.getElementsByClassName("c-accordion-gallery__image");

		$(images).fadeOut("fast");

		const itemsOpen = $('.c-accordion-gallery__item-header[aria-current="true"]');
		const element = [...Object(itemsOpen)];

		element.forEach(function (dataAttribute) {

			var attribute = $(dataAttribute).data("attribute");
			var itsImage = $(".c-accordion-gallery__image[data-attr='" + attribute + "']");

			itsImage.fadeIn("fast");
		});

		$(item).click(function () {

			$(images).fadeOut("fast");

			if ($(this).attr('aria-current') === 'false') {

				var dataAttribute = $(this).data("attribute");
				var itsImage = $(".c-accordion-gallery__image[data-attr='" + dataAttribute + "']");

				itsImage.fadeIn("fast");

			} else {

				$(images).fadeOut("fast");
			}
		});
	});
}

//  Property Gallery Input

function InputPlaceholder() {

	var input = $(".c-property-carousel__banner-search-box");
	var placeholderText = input?.data('placeholder');

	if ($(window).width() < 768) {
		$(".c-property-carousel__banner-search-box").attr("placeholder", "Search Rentals");
	} else {
		$(".c-property-carousel__banner-search-box").attr("placeholder", placeholderText);
	}
}

$(document).ready(function () {
	InputPlaceholder()
});

$(window).resize(function () {
	InputPlaceholder()
});